import React from "react";

const CheckCircleIcon = () => (
  <div style={{ color: "#37B450", display: "flex" }}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="#37B450"
        strokeWidth="2"
        fill="#37B450"
      />
      <path
        d="M16 10L10.5 15.5L8 13"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);

export default CheckCircleIcon;
